import { SpacingOptions } from "@mui/system/createTheme/createSpacing";

export const spacing: SpacingOptions = (token: number) => (token * 2) / 25;
